import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import ParkingMeterDTO from '../../../dto/ParkingMeterDTO';
import {
  PARKING_METER_AVAILABLE_STATUS,
  PARKING_METER_STATUS,
  pssKeysT,
  printerKeysT,
  powerKeysT,
  paymentKeysT, lowDoorKeysT, upDoorKeysT, lowLockKeysT, upLockKeysT,
} from '../constants';
import { optionClassFormatter } from '../../../utils/formatters';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import CheckBoxAccordion from '../../../components/fields/CheckBoxInput/CheckBoxList';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import FilterDTO from '../../../dto/FilterDTO';
import { FilterPresets } from './ParkingMeterFilter';
import { getCheckClassByName } from '../parking-meter-utils';
import RadioButton from '../../../components/fields/RadioButton/RadioButton';
import RadioList from '../../../components/fields/CheckBoxInput/RadioList';

const updatePeriods = [
  { value: 0, name: 'Не обновлять' },
  { value: 10, name: '10 секунд' },
  { value: 30, name: '30 секунд' },
  { value: 60, name: '1 минута' },
  { value: 300, name: '5 минут' },
];

export default function MobileParkingMeterFilter(props) {
  const {
    onHide, resetField, meta, reset = () => {}, zones, register, getValues, setValue, defaultValues, handleLoadingHostList = () => {},
    changeUpdatePeriod = () => {},
    updatePeriod,
  } = props;
  const DTO = new ParkingMeterDTO();
  const filterDto = new FilterDTO();
  const attributes = DTO.getAttributesByName();
  const filterAttributes = filterDto.getAttributesByName();
  const intl = useIntl();
  const availableStatusOptions = Object.values(PARKING_METER_AVAILABLE_STATUS).map(v => ({ value: Number(v), nameId: `parking.meter.available_status.${v}` })).reverse();
  const statusOptions = Object.values(PARKING_METER_STATUS).map(v => ({ value: Number(v), nameId: `parking.meter.status.${v}` })).reverse();
  const zonesOptions = zones.map(i => ({ name: i, value: i }));
  const selectedStatus = statusOptions.find(i => i.value === Number(getValues('status')));
  const selectedAvailableStatus = availableStatusOptions.find(i => i.value === Number(getValues('available_status')));
  const onShow = () => {
    handleLoadingHostList();
  };
  const clear = () => {
    reset(defaultValues);
  };

  const renderCheckBox = (name, index) => (
    <FieldWithAttributeDTO
      key={index}
      type="text"
      component={CheckBoxInputWithLabel}
      dtoObject={filterAttributes[name]}
      className={getCheckClassByName(name)}
      withLabel
      addPlaceholder
      variant="material"
      inputProps={{
        value: getValues(name),
        ...register(name),
        onChange: () => setValue(name, !getValues(name)),
      }}
    />
  );

  return (
    <Dialog
      className={classNames('parking-meter-full-filter mobile')}
      onClose={onHide}
      open
    >
      <DialogTitle
        className="pmff-title"
        title={(
          <>
            <div className="pmff-title-text f2">Фильтры</div>
            <div className="pmff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="pmff-close" onClick={onHide} />
            </div>
          </>
      )}
      />
      <DialogContent className="pff-content">
        <form>
          <div>
            <CustomSelectInput
              label="Период обновления"
              placeholder="Период обновления"
              dtoObject={attributes.status}
              inputProps={{
                value: getValues('update_period'),
                ...register('update_period'),
                onChange: event => { setValue('update_period', event.target.value || 0); changeUpdatePeriod(event.target.value || 0); },
              }}
              options={updatePeriods}
              className="search-field"
              variant="material"
              withLabel
            />
            <FieldWithAttributeDTO
              type="text"
              component={TextInput}
              withLabel
              dtoObject={{
                name: 'query',
                type: String,
                validators: [],
                labelKey: 'search',
              }}
              inputProps={{
                ...register('query', { maxLength: 30 }),
                value: getValues('query'),
              }}
              className="search-field"
              variant="material"
            />
            <FieldWithAttributeDTO
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.zbx_address}
              inputProps={{
                value: getValues('address'),
                ...register('address'),
              }}
              variant="material"
              withLabel
            />
            <FieldWithAttributeDTO
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.host}
              inputProps={{
                value: getValues('host'),
                ...register('host'),
              }}
              variant="material"
              withLabel
            />
            <FieldWithAttributeDTO
              type="text"
              component={CustomSelectInput}
              dtoObject={attributes.zbx_zone}
              addPlaceholder
              options={zonesOptions}
              inputProps={{
                ...register('zbx_zone'),
                value: getValues('zbx_zone'),
                onChange: e => {
                  setValue('zbx_zone', e.target.value);
                },
              }}
              variant="material"
              withLabel
            />
            <RadioList label="Доступность" selectedValue={selectedAvailableStatus} clearFilter={() => reset({ ...getValues(), available_status: 0 })} keys={[]}>
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.available_status}
                className="mt-4"
                withLabel
                addPlaceholder
                options={availableStatusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('available_status'),
                  value: Number(getValues('available_status')),
                  onChange: e => {
                    setValue('available_status', Number(e.target.value));
                  },
                }}
              />
            </RadioList>
            <RadioList label="Состояние" selectedValue={selectedStatus} clearFilter={() => reset({ ...getValues(), status: 0 })} keys={[]}>
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.status}
                className="mt-4"
                withLabel
                addPlaceholder
                options={statusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('status'),
                  value: Number(getValues('status')),
                  onChange: e => {
                    setValue('status', Number(e.target.value));
                  },
                }}
              />
            </RadioList>
          </div>
          <CheckBoxAccordion label="Нижняя дверь" clearFilter={() => reset({ ...getValues(), ...lowDoorKeysT })} setFilterValue={setValue} keys={Object.keys(lowDoorKeysT)} filter={getValues()}>
            {Object.keys(lowDoorKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Верхняя дверь" clearFilter={() => reset({ ...getValues(), ...upDoorKeysT })} setFilterValue={setValue} keys={Object.keys(upDoorKeysT)} filter={getValues()}>
            {Object.keys(upDoorKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Замок на нижней двери" clearFilter={() => reset({ ...getValues(), ...lowLockKeysT })} setFilterValue={setValue} keys={Object.keys(lowLockKeysT)} filter={getValues()}>
            {Object.keys(lowLockKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Замок на верхней двери" clearFilter={() => reset({ ...getValues(), ...upLockKeysT })} setFilterValue={setValue} keys={Object.keys(upLockKeysT)} filter={getValues()}>
            {Object.keys(upLockKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Связь с парковочным сервером" clearFilter={() => reset({ ...getValues(), ...pssKeysT })} setFilterValue={setValue} keys={Object.keys(pssKeysT)} filter={getValues()}>
            <FilterPresets
              keys={Object.keys(pssKeysT)}
              errorKeys={['PSS_ERROR', 'PSS_UNREGISTERED']}
              warningKeys={['PSS_UNKNOWN']}
              setValue={setValue}
              getValues={getValues}
              reset={reset}
              resetField={resetField}
            />
            {Object.keys(pssKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Принтер" clearFilter={() => reset({ ...getValues(), ...printerKeysT })} setFilterValue={setValue} keys={Object.keys(printerKeysT)} filter={getValues()}>
            <FilterPresets
              keys={Object.keys(printerKeysT)}
              errorKeys={['PS_ERROR', 'PS_PAPER_EMPTY']}
              warningKeys={['PS_PAPER_LOW', 'PS_UNKNOWN']}
              setValue={setValue}
              getValues={getValues}
              reset={reset}
              resetField={resetField}
            />
            {Object.keys(printerKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Контроллер питания" clearFilter={() => reset({ ...getValues(), ...powerKeysT })} setFilterValue={setValue} keys={Object.keys(powerKeysT)} filter={getValues()}>
            <FilterPresets
              keys={Object.keys(powerKeysT)}
              errorKeys={['POWER_ERROR']}
              warningKeys={['POWER_LOW_POWER', 'POWER_UNKNOWN']}
              setValue={setValue}
              getValues={getValues}
              reset={reset}
              resetField={resetField}
            />
            {Object.keys(powerKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
          <CheckBoxAccordion label="Модуль оплаты" clearFilter={() => reset({ ...getValues(), ...paymentKeysT })} setFilterValue={setValue} keys={Object.keys(paymentKeysT)} filter={getValues()}>
            {Object.keys(paymentKeysT).map(renderCheckBox)}
          </CheckBoxAccordion>
        </form>
      </DialogContent>
      <DialogFooter className="pmff-footer">
        <div className="pmff-footer-buttons">
          <Button className="pmff-clear-data" variant="secondary" onClick={clear}>Сбросить</Button>
          <Button className="pmff-clear-show" onClick={() => { onHide(); onShow(); }}>Показать</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
